import useSWR from "swr";
import { useCreateHeyLightAdminAxiosInstance } from "../../Auth/useCreateHeyLightAdminAxiosInstance.ts";
import { HeyLightProductDTO } from "../../HeyLight/useHeyLightProductById.ts";

export function useAllHeyLightProducts() {
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();
  const { data, error, isLoading } = useSWR(`/product`, async (url) => {
    const { data } = await createAxiosInstance().get<{
      products: HeyLightProductDTO[];
    }>(url);

    return data;
  });

  return {
    products: data?.products ?? [],
    error,
    isLoading: isLoading,
  };
}
